// 'core-js/stable' does NOT include polyfill for Symbol.Observable which is needed for IE11 / Trident / MSHTM
import 'core-js';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

// Polyfill for IE11 / Trident / MSHTM since index is a required parameter.
// https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/insertRule
(function (Sheet_proto) {
  const originalInsertRule = Sheet_proto.insertRule;
  Sheet_proto.insertRule = function (rule, index) {
    if (index === undefined) {
      return originalInsertRule.call(this, rule, this.cssRules.length);
    }

    return originalInsertRule.call(this, rule, index);
  };
})(CSSStyleSheet.prototype);
